<template>
  <div class="register">
    <div class="card register-card card-design">
      <div class="mobile-head">
        <img
          class="img-background-fade"
          src="../assets/background_01.jpg"
          alt="background"
        />
      </div>
      <div class="card-body">
        <div class="card-headline">
          <img class="logo" src="../assets/logo.svg" alt="BlackJack" />
          <h3 class="custom-headline">
            Ahoi, furchtlose Piraten!
          </h3>
          <div>
            Ihr müsst euch zuerst registrieren, damit ihr eure persönlichen
            Strecken konfigurieren oder euch die Black Jack-Statistiken ansehen
            könnt.
          </div>
        </div>
        <div v-if="!isLoggedIn && token !== ''" class="card-input-wrapper">
          <div class="card-input-container">
            <!-- Nickname -->
            <div class="card-input-description">
              Nickname *
            </div>
            <b-input-group id="input-group-username">
              <b-input-group-prepend>
                <span class="input-group-text">
                  <UserIcon title="Username" />
                </span>
              </b-input-group-prepend>
              <b-form-input
                id="input-username"
                v-model.trim="username"
                :maxlength="20"
                :state="validUsername"
                aria-describedby="input-username-feedback"
                type="text"
                required
                placeholder="Max_Muster"
                class="input-with-icon"
              >
              </b-form-input>
              <b-form-invalid-feedback id="input-username-feedback">
                <span>
                  Dein Nickname muss mind. 3 Buchstaben oder Zahlen haben.
                </span>
              </b-form-invalid-feedback>
            </b-input-group>
            <hr class="card-hr" />
            <!-- Password -->
            <div class="card-input-description">
              Passwort *
            </div>
            <b-input-group id="input-group-password" :state="validPassword">
              <b-input-group-prepend>
                <span class="input-group-text">
                  <PasswordIcon title="Passwort" />
                </span>
              </b-input-group-prepend>
              <b-form-input
                id="input-password"
                v-model.trim="password"
                :state="validPassword"
                :maxlength="4"
                aria-describedby="input-password-feedback"
                type="password"
                required
                placeholder="4-stelliger Zahlencode"
                class="input-with-icon"
              >
              </b-form-input>
              <b-form-invalid-feedback id="input-password-feedback">
                Passwort muss aus 4 Zahlen bestehen.
              </b-form-invalid-feedback>
            </b-input-group>
            <hr class="card-hr" />
            <!-- confirm password -->
            <div class="card-input-description">
              Passwort wiederholen *
            </div>
            <b-input-group
              id="input-group-password-confirm"
              :state="confirmPassword"
            >
              <b-input-group-prepend>
                <span class="input-group-text">
                  <PasswordIcon title="Passwort wiederholen" />
                </span>
              </b-input-group-prepend>
              <b-form-input
                id="input-password-confirm"
                v-model.trim="password2"
                :state="confirmPassword"
                :maxlength="4"
                aria-describedby="input-password2-feedback"
                type="password"
                required
                placeholder="4-stelliger Zahlencode"
                class="input-with-icon"
              >
              </b-form-input>
              <b-form-invalid-feedback id="input-password2-feedback">
                Passwort muss übereinstimmen.
              </b-form-invalid-feedback>
            </b-input-group>
            <hr class="card-hr" />
            <!-- Age -->
            <div class="card-input-description">
              Geburtsdatum
            </div>
            <b-input-group id="input-group-date">
              <b-input-group-prepend>
                <span class="input-group-text">
                  <AgeIcon title="Geburtsdatum" />
                </span>
              </b-input-group-prepend>
              <b-form-input
                id="input-date"
                v-model="date"
                type="date"
                required
                class="input-with-icon"
              >
              </b-form-input>
            </b-input-group>
            <hr class="card-hr" />
            <!-- Gender -->
            <div class="card-input-description">
              Geschlecht
            </div>
            <b-input-group id="input-group-gender">
              <b-input-group-prepend>
                <span class="input-group-text">
                  <GenderIcon title="Geschlecht" />
                </span>
              </b-input-group-prepend>
              <b-form-select
                id="input-gender"
                v-model="gender"
                :options="genderOptions"
                required
                class="input-with-icon"
              >
                <template slot="first">
                  <option :value="null" disabled>
                    Bitte triff deine Auswahl
                  </option>
                </template>
              </b-form-select>
            </b-input-group>
          </div>
        </div>
        <div v-if="!isLoggedIn && token !== ''" class="card-body-confirm">
          <div class="confirm-note">
            Mit * gekennzeichnete Felder sind Pflichtfelder.
          </div>
          <button
            v-if="!isPending"
            :class="{
              disabled: username === '' || !confirmPassword || !validPassword
            }"
            class="btn start-btn"
            @click="register"
          >
            Jetzt registrieren
          </button>
          <div v-else>
            Bitte warten...
          </div>
        </div>
        <div
          v-if="isLoggedIn || token === ''"
          class="card-body-confirm missing-token"
        >
          <div v-if="isLoggedIn">
            <div>
              Hi {{ name }}, du bist bereits eingeloggt. Hier kannst du dich
              ausloggen:
            </div>
            <button class="btn" @click="logout">Logout</button>
          </div>
          <div v-else-if="token === ''">
            Hi, bitte geh zurück auf BadSchallerbach.com und klicke auf "Neuen
            Rutscher anlegen"
          </div>
        </div>
        <Footer />
      </div>
    </div>
    <Notification
      :show="notification.show"
      :title="notification.title"
      :text="notification.text"
      :error="notification.error"
      @okay="notification.show = false"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import UserIcon from "vue-material-design-icons/Account";
import PasswordIcon from "vue-material-design-icons/Lock";
import AgeIcon from "vue-material-design-icons/Cake";
import GenderIcon from "vue-material-design-icons/GenderTransgender";
import Notification from "../components/Notification";
import Footer from "../components/Footer";

export default {
  name: "Register",
  components: {
    UserIcon,
    PasswordIcon,
    AgeIcon,
    GenderIcon,
    Notification,
    Footer
  },
  data() {
    return {
      username: "",
      password: "",
      password2: "",
      token: "",
      gender: null,
      genderOptions: [
        { value: "D", text: "Divers" },
        { value: "M", text: "Männlich" },
        { value: "W", text: "Weiblich" }
      ],
      date: null,
      notification: {
        show: false,
        title: "",
        text: "",
        error: {}
      }
    };
  },
  computed: {
    ...mapGetters("authentication", ["isLoggedIn", "name", "isPending"]),
    validUsername() {
      let length = this.username.length;
      if (length === 0) {
        return null;
      } else return length >= 3;
    },
    validPassword() {
      let length = this.password.length;
      if (length === 0) {
        return null;
      } else if (length === 4) {
        const pattern = new RegExp("^[0-9]{4}");
        return pattern.test(this.password);
      } else {
        return false;
      }
    },
    confirmPassword() {
      if (this.password2 === "") {
        return null;
      } else return this.password === this.password2;
    }
  },
  mounted() {
    if (typeof this.$route.query.token !== "undefined") {
      this.token = this.$route.query.token;
    }
  },
  methods: {
    ...mapActions("authentication", ["login", "logout"]),
    async logMeIn() {
      try {
        await this.login({
          username: this.username,
          password: this.password
        });
        this.username = "";
        this.password = "";
        this.$router.push({ name: "home" });
      } catch (e) {
        this.password = "";
        console.log(e);
      }
    },
    async register() {
      if (this.validUsername && this.confirmPassword && this.validPassword) {
        try {
          await this.axios.post("/api/register", {
            user_name: this.username,
            code: this.password,
            token: this.token,
            gender: this.gender,
            birthdate: this.date
          });
          this.password2 = "";
          // auto login
          this.logMeIn();
        } catch (e) {
          if (typeof e.response !== "undefined") {
            this.notification.error = e.response;
            console.log(e.response.data);
            this.showNotification("", "");
          } else {
            this.e = {};
            this.showNotification(
              "Oops!",
              "Da ist etwas schief gelaufen. Bitte probiere es erneut!"
            );
            console.log(e);
          }
        }
      }
    },
    showNotification(title, text) {
      this.notification.title = title;
      this.notification.text = text;
      this.notification.show = true;
    }
  }
};
</script>

<style scoped></style>
